import {
  LocallyStoredRegistrationData,
  RegisteredItem,
  RegisteredItemProductDetails,
  RegistrationApplianceDetails,
  RegistriaUsersResponse,
  SerializationCodeResponse,
} from '@us-registration/util-models';

export function registeredItemToRegisteredItemProductDetails(
  registeredItem?: RegisteredItem
): RegisteredItemProductDetails[] {
  if (!registeredItem || !registeredItem.products) {
    return [];
  }

  return registeredItem.products.map(
    (registeredItemProductDetails: RegisteredItemProductDetails) => ({
      ...registeredItemProductDetails,
    })
  );
}

export function getConfirmationRegistrationApplianceDetails(
  registeredItemAppliances: RegistrationApplianceDetails[],
  serializationCodeResponse?: SerializationCodeResponse
): RegistrationApplianceDetails[] {
  if (!serializationCodeResponse) {
    return registeredItemAppliances;
  } else {
    return registeredItemAppliances.map(
      (registeredItemAppliance: RegistrationApplianceDetails) => ({
        ...registeredItemAppliance,
        type: serializationCodeResponse.Type,
      })
    );
  }
}

export function setLocalStorageConfirmationData(
  registeredItem: RegisteredItem,
  serializationCodeResponse?: SerializationCodeResponse
): void {
  let registeredItemAppliances: LocallyStoredRegistrationData[] = [];
  if (registeredItem) {
    registeredItemAppliances = registeredItem.appliances.map(
      (appliances: RegistrationApplianceDetails) => {
        return {
          brand: appliances.brand,
          modelNumber: appliances.modelNumber,
          purchaseDate: appliances.purchaseDate,
          purchaseFrom: appliances.purchaseFrom,
          purchasePrice: appliances.purchasePrice,
          serialNumber: appliances.serialNumber,
          type: !serializationCodeResponse
            ? appliances.type
            : serializationCodeResponse.Type,
        };
      }
    );
  }
  localStorage.removeItem('confirmationData');
  const stringifiedObj = JSON.stringify(registeredItemAppliances);
  localStorage.setItem('confirmationData', stringifiedObj);
}

export function setLocalStorageRegistriaData(
  registriaResponse?: RegistriaUsersResponse
): void {
  if (registriaResponse) {
    localStorage.removeItem('registriaUserResponse');
    const stringifiedObj = JSON.stringify({
      sessionId: registriaResponse.sessionId,
      ...(registriaResponse.snippet_data && {
        snippet_data: registriaResponse.snippet_data,
      }),
    });
    localStorage.setItem('registriaUserResponse', stringifiedObj);
  }
}
